<div class="button-menu">
  @for (size of sizes; track size) {
    <app-button-menu-item
      [name]="'download-' + (size.name | lowercase)"
      location="download-size-selection"
      (click)="onSelect.emit(size.size)"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b [class.active]="size.size === activeLongEdge">{{ size.name | translate }}</b>
        @if (getHeight(size.size)) {
          <span>({{ getWidth(size.size) }} x {{ getHeight(size.size) }})</span>
        }
        @if (size.size === activeLongEdge) {
          <app-svg src="/assets/icons/check.svg"></app-svg>
        }
      </div>
    </app-button-menu-item>
  }
  @if (sizes.length && allowOriginalDownload) {
    <div class="divider"></div>
  }
  @if (allowOriginalDownload) {
    <app-button-menu-item
      name="download-original"
      location="download-size-selection"
      (click)="onSelect.emit()"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b [class.active]="!activeLongEdge && activeLongEdge !== undefined">{{ 'original-file' | translate }}</b>
        @if (asset.version_data.data?.width) {
          <span>({{ asset.version_data.data.width }} x {{ asset.version_data.data.height }})</span>
        }
        @if (!activeLongEdge && activeLongEdge !== undefined) {
          <app-svg src="/assets/icons/check.svg"></app-svg>
        }
      </div>
    </app-button-menu-item>
  }
</div>
